import './header-cart';
import './search/search';

$(document).ready(function () {
    $('header .header-menu__collapse').on('click tap', function () {
        $(this).children('.dropdown-toggle').next('.header-submenu').slideToggle()
    });
    $('.header-toggler').on('click tap', function () {
        $('header').toggleClass('show');
        $('body').toggleClass('overflow-hidden');
        $(this).next('.header-menu').toggleClass('show')
    });
    $('.header-search-ico').on('click tap', function () {
        $(this).parent().find('.search-form').toggleClass('search-open')
    });
});



$(document).scroll(function () {
    let heroTitle = false;
    if ($('section').is('.hero-title')) {
        heroTitle = true;
    }
    if ($(window).width() <= 992 && heroTitle) {
        let count_scroll = pageYOffset;
        let target_div = $('.hero-title').offset().top + $('.hero-title').height();
        if (count_scroll > target_div) {
            $('header').addClass('header-white');
        }
        if (count_scroll < target_div) {
            $('header').removeClass('header-white');
        }
    }
})